import React from 'react'
import { useProject } from '@/app/routes/Dashboard/Dashboard.hooks'
import Container from 'react-bootstrap/esm/Container'
import Row from 'react-bootstrap/esm/Row'
import Col from 'react-bootstrap/esm/Col'
import classes from './Dashboard.module.scss'
import ProjectSection from '@/app/routes/Dashboard/ProjectSection'
import TrialSection from '@/components/TrialSection'

const Dashboard = () => {
  const [project, legacyProjects] = useProject()

  const getLegacyProjectTitle = (title: string) => {
    if (title === 'Flow') return title
    return `${title} (legacy)`
  }

  return (
    <div className={classes.root}>
      <Container>
        <Row className={classes.row}>
          <Col>
            <TrialSection />
          </Col>
        </Row>
        <Row className={classes.row}>
          <Col>
            <ProjectSection title="Routes" project={project} />
          </Col>
        </Row>
        {legacyProjects.map((legacyProject) => {
          return (
            <Row key={legacyProject.id} className={classes.row}>
              <Col>
                <ProjectSection title={getLegacyProjectTitle(legacyProject.name)} project={legacyProject} />
              </Col>
            </Row>
          )
        })}
      </Container>
    </div>
  )
}

export default Dashboard
